import { opacity } from '../../utils';
import { grayPalette } from '../../themes/colors';

export const modalLightTheme = {
  footer: {
    backgroundColor: grayPalette[100],
  },
  overlay: {
    backgroundColor: opacity(grayPalette[1000], 20),
  },
};
